import React from 'react';
import Cart from './Cart';
import Navbar from './Navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Cart />
    </div>
  );
}

export default App;
